import { Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProcessorService {
    static subject = new Subject<void>();
    static injectorSubject = new Subject<void>();

    static injector: Injector;

    constructor(injector: Injector) {
        ProcessorService.injector = injector;
        ProcessorService.injectorSubject.next();
    }

    static ready(): void {
        ProcessorService.subject.complete();
    }

    static onReady(cb: () => void | any): void {
        if (ProcessorService.injector) {
            cb();
        } else {
            ProcessorService.subject.subscribe({ complete: cb });
        }
    }
}
